function init (registerComponentRefreshCallback) {
  renderAllBoxes()
  registerComponentRefreshCallback('color-box', refreshBox)
}

function renderAllBoxes () {
  const colorBoxes = document.querySelectorAll('.color-box, .color-box-with-image')
  colorBoxes.forEach(prepareBox)
}

function refreshBox (sectionElement) {
  const colorBox = sectionElement?.querySelector('.color-box, .color-box-with-image')
  if (colorBox) prepareBox(colorBox)
}

function prepareBox (box) {
  applyColor(box)
  box.classList.add('is-ready')
}

function applyColor (box) {
  let color = box.getAttribute('data-color')
  if (!color) return

  if (!color.startsWith('#')) {
    color = '#' + color
  }

  if (box.classList.contains('color-box-with-image')) {
    const textCol = box.querySelector('.color-box-with-image_text-col')
    if (textCol) {
      textCol.style.backgroundColor = color
    }
  } else {
    box.style.backgroundColor = color
  }
}

export default { init }
